/**
 * First-party Segment proxy. `GATSBY_SEGMENT_PROXY_HOST` holds a bare host, for
 * example `t-uat.lesmillsplus.com`. Leave it empty to send direct to Segment.
 */
const proxyHost = process.env.GATSBY_SEGMENT_PROXY_HOST?.replace(/^https?:\/\//, '').replace(
  /\/$/,
  ''
);

interface ProxySettings {
  cdnURL?: string;
}

interface ProxyOptions {
  integrations?: {
    'Segment.io': {
      apiHost: string;
      protocol: string;
    };
  };
}

/**
 * Routes the settings and bundle fetch through the proxy.
 * Merge into the first argument of `AnalyticsBrowser.load`.
 */
export const segmentProxySettings = (): ProxySettings =>
  proxyHost ? { cdnURL: `https://${proxyHost}` } : {};

/**
 * Routes tracking calls through the proxy.
 * Pass as the second argument of `AnalyticsBrowser.load`.
 */
export const segmentProxyOptions = (): ProxyOptions =>
  proxyHost
    ? {
        integrations: {
          'Segment.io': {
            apiHost: `${proxyHost}/v1`,
            protocol: 'https',
          },
        },
      }
    : {};
